"use strict";
var r, e;
function i() {
  return e || (e = 1, r = URIError), r;
}
export {
  i as __require
};
//# sourceMappingURL=index.es309.js.map
